import { useQuery, gql, useLazyQuery } from '@apollo/client';
import { CursosPageQuery, CursosPageQueryVariables } from './__generated__/CursosPageQuery';

const CURSOS_QUERY = gql`
  query CursosPageQuery($descricao: String, $pagina: Int, $itens_por_pagina: Int) {
    cursos(
      filter: { descricao: $descricao, pagina: $pagina, itens_por_pagina: $itens_por_pagina }
    ) {
      id_curso
      id_unidade
      dsc_nome_curso
      dsc_sigla_curso
      id_apoio
      apoio {
        id_apoio
        dsc_nome
      }
      ativo

      ofertas {
        id_oferta
        num_oferta
        num_ano
        num_semestre
        ativa
        id_assistente
        assistente {
          id_assistente
          dsc_nome
          dsc_email
        }
        dat_inicio
        dat_fim

        turmas {
          id_turma
          id_horario
          num_turma
          dias_semana
          ativa
        }
      }
    }

    apoios {
      id_apoio
      dsc_nome
    }

    assistentes {
      id_assistente
      dsc_nome
    }

    unidades {
      id_unidade
      dsc_nome_unidade
    }

    horarios {
      id_horario
      hora_inicio
      hora_fim
    }
  }
`;

const useCursosPageQuery = (variables: CursosPageQueryVariables) => {
  return useQuery<CursosPageQuery, CursosPageQueryVariables>(CURSOS_QUERY, {
    variables,
  });
};

const useCursosLazyQuery = () => {
  return useLazyQuery<CursosPageQuery, CursosPageQueryVariables>(CURSOS_QUERY);
};

export { useCursosPageQuery, useCursosLazyQuery };
